export const isCustomCursorActive = () =>
  typeof document !== 'undefined' &&
  document.documentElement.classList.contains('custom-cursor-active');

export const configureSplineAppForCustomCursor = (app) => {
  if (!app?.setGlobalEvents) {
    return;
  }

  app.setGlobalEvents(true);
};

export const isSplineIframeElement = (target) => {
  if (!(target instanceof Element)) {
    return false;
  }

  return Boolean(target.closest('iframe.spline-iframe, iframe.hero-spline-iframe'));
};
